import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import { ReactComponent as DropdownIcon } from 'images/common/dropdown.svg'
import { ReactComponent as ActiveIcon } from 'images/checkbox/active.svg'
import { ReactComponent as InactiveIcon } from 'images/checkbox/inactive.svg'
import { searchGroupsData } from '../../../utils'
import styles from '../StationSelector.module.scss'
import { useStationGroups } from 'components/analytics/context/StationGroupsContext'
import { ReactComponent as LoadingIcon } from 'images/common/loading.svg'

const cx = classNames.bind(styles)

const GroupList = ({
  groups,
  value,
  search,
  handleDropdownItemClick
}) => {
  const { groupsLoading } = useStationGroups()

  const [activeParentGroup, setActiveParentGroup] = useState('')
    
  const groupsToDisplay = search ? searchGroupsData(groups, search) : groups

  const handleParentGroupClick = (parentGroupName) => {
    setActiveParentGroup(parentGroupName === activeParentGroup ? '' : parentGroupName)
  }

  const selectedGroupsCount = {};

  for (const groupSet of groups) {
    const { parentGroup, childGroups } = groupSet;
    // Collect all groupIds under this parentGroup
    const groupIds = childGroups.map(group => group.groupId);

    // Count how many of those groupIds are in the values array
    const count = groupIds.filter(id => value.includes(id)).length;

    selectedGroupsCount[parentGroup] = count;
  }

  return (
    <div className={`${cx('items-list')} ${cx('dropdown-wrapper')}`}>
      {groupsLoading && <div className={cx('loader-wrapper')}><LoadingIcon height={40} width={40} /></div>}
      {!groupsLoading && groupsToDisplay.map(group => (
        <div key={group.parentGroup}>
          <div className={cx('item', 'dropdown-parent')} onClick={() => handleParentGroupClick(group.parentGroup)}>
            {group.parentGroup} {selectedGroupsCount[group.parentGroup] > 0 && '(' + selectedGroupsCount[group.parentGroup] + ')'}
            <DropdownIcon className={cx('dropdown-icon', { active: group.parentGroup === activeParentGroup || search })} />
          </div>
          {(group.parentGroup === activeParentGroup || search) && (
            <div className={cx('dropdown-child-wrapper')}>
              {group.childGroups && group.childGroups.length > 0 ? (
                group.childGroups.map(childGroup => (
                  <div
                    key={childGroup.name}
                    className={cx('item', 'dropdown-child')}
                    onClick={(e) => handleDropdownItemClick(e, childGroup.groupId)}
                  >
                    <div>
                      {childGroup.name}
                      <div className={cx('station-count')}>
                        {childGroup.stationsCount} stations
                      </div>
                    </div>
                    {value.includes(childGroup.groupId) ? <ActiveIcon /> : <InactiveIcon />}
                  </div>
                ))
              ) : (
                <div
                  className={cx('item', 'dropdown-child')}
                >
                  No groups available
                </div>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

GroupList.propTypes = {
  groups: PropTypes.array.isRequired,
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
  search: PropTypes.string,
  handleDropdownItemClick: PropTypes.func.isRequired
}

export default GroupList
